<template>
  <div class="card-verification-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.create_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 31)"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.return_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 31)"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.account_no') }}</div>
              <el-input
                v-model="search.account_no"
                size="small"
                type="text"
                maxlength="32"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.account_status') }}</div>
              <el-select v-model="search.account_validate_result" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="item in accountStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.order_status') }}</div>
              <el-select v-model="search.transaction_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="item in transactionStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.name_match_result') }}</div>
              <el-select v-model="search.name_match_result" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="item in nameMatchResultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.merchant_order_id') }}</div>
              <el-input
                v-model="search.mch_order_id"
                size="small"
                type="text"
                maxlength="32"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.transaction_id') }}</div>
              <el-input
                v-model="search.transaction_id"
                size="small"
                type="text"
                maxlength="32"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.account_actual_type') }}</div>
              <el-select v-model="search.real_account_type" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="item in accountTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <div class="total-container">
      <div class="total-item">
        {{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">
        {{ $t('data.total_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_fee_split | toDivideWithDot }}</span>
      </div>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('data.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_bank_code')" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.account_bank_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_name')" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_status')" align="center" min-width="110">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getAccountStatusType(scope.row.account_validate_result)">{{ getAccountStatusLabel(scope.row.account_validate_result) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.order_status')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getTransactionStatusType(scope.row.transaction_status)">{{ getTransactionStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.name_match_result')" align="center" min-width="120">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getNameMatchResultType(scope.row.name_match_result)">{{ getNameMatchResultLabel(scope.row.name_match_result) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_actual_type')" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ getAccountTypeLabel(scope.row.real_account_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_kyc_result')" align="center" min-width="110">
          <template slot-scope="scope">
            <span>{{ getAccountKycResultLabel(scope.row.account_kyc_result) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('dashboard.fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column width="105" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column width="105" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <CardVerificationDetailModal
      ref="cardVerificationDetailModal"
      :visible.sync="detailModalVisible"
    />
  </div>
</template>

<script>
import { fetchCardValidationList, fetchCardValidationListDownload, fetchCardValidationDetail } from '@/api/data/data'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import { cardValidationStatusMap, accountNameMatchResultMap, accountValidateResultMap, accountTypeMap, accountKycResultMap } from '@/utils/maps'
import CardVerificationDetailModal from './Modal/CardVerificationDetailModal.vue'

export default {
  name: 'Card_Verification_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    CardVerificationDetailModal
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        create_times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        return_times: [],
        account_no: '',
        account_validate_result: null,
        transaction_status: null,
        name_match_result: null,
        mch_order_id: '',
        transaction_id: '',
        real_account_type: null
      },
      tableData: [],
      total_count: 0,
      total_fee_split: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      detailModalVisible: false
    }
  },
  computed: {
    accountStatusOptions() {
      return accountValidateResultMap()
    },
    getAccountStatusType() {
      return function(value) {
        return accountValidateResultMap(value)?.type || 'info'
      }
    },
    getAccountStatusLabel() {
      return function(value) {
        return accountValidateResultMap(value)?.label || '-'
      }
    },
    accountTypeOptions() {
      return accountTypeMap()
    },
    getAccountTypeLabel() {
      return function(value) {
        return accountTypeMap(value)?.label || '-'
      }
    },
    getAccountKycResultLabel() {
      return function(value) {
        return accountKycResultMap(value)?.label || '-'
      }
    },
    nameMatchResultOptions() {
      return accountNameMatchResultMap()
    },
    transactionStatusOptions() {
      return cardValidationStatusMap()
    },
    getTransactionStatusType() {
      return function(value) {
        return cardValidationStatusMap(value)?.type || 'info'
      }
    },
    getTransactionStatusLabel() {
      return function(value) {
        return cardValidationStatusMap(value)?.label || '-'
      }
    },
    getNameMatchResultType() {
      return function(value) {
        return accountNameMatchResultMap(value)?.type || 'info'
      }
    },
    getNameMatchResultLabel() {
      return function(value) {
        return accountNameMatchResultMap(value)?.label || '-'
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getCardValidationList(params) {
      this.listLoading = true
      fetchCardValidationList(params).then((res) => {
        const { total = 0, list = [] } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_count = res.data.total_count
        this.total_fee_split = res.data.total_fee_split
        this.total_fee = 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { create_times = [], return_times = [], account_no, account_validate_result, transaction_status, name_match_result, mch_order_id, transaction_id, real_account_type } = this.search
      let params = {
        account_no,
        account_validate_result,
        transaction_status,
        name_match_result,
        mch_order_id,
        transaction_id,
        real_account_type,
        create_start_date_time: create_times && create_times[0],
        create_end_date_time: create_times && create_times[1],
        return_start_date_time: return_times && return_times[0],
        return_end_date_time: return_times && return_times[1],
        is_search_count: true,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getCardValidationList(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {
        create_times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        return_times: [],
        account_no: '',
        account_validate_result: null,
        transaction_status: null,
        name_match_result: null,
        mch_order_id: '',
        transaction_id: '',
        real_account_type: null
      }
    },
    onClickDowmloadBtn() {
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      fetchCardValidationListDownload(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Card_Verification_List')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('data.transaction_id'),
        this.$t('data.merchant_order_id'),
        this.$t('data.account_no'),
        this.$t('data.account_bank_code'),
        this.$t('data.account_name'),
        this.$t('data.account_status'),
        this.$t('data.order_status'),
        this.$t('data.name_match_result'),
        this.$t('data.account_actual_type'),
        this.$t('data.proxy_type'),
        this.$t('data.passport_country_code'),
        this.$t('data.fee'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.transaction_id,
            tr.mch_order_id,
            tr.account_no,
            tr.account_bank_code,
            tr.account_name,
            this.getAccountStatusLabel(tr.account_validate_result) || '-',
            this.getTransactionStatusLabel(tr.transaction_status),
            tr.name_match_result ? this.getNameMatchResultLabel(tr.name_match_result) : '-',
            this.getAccountTypeLabel(tr.real_account_type) || '-',
            tr.proxy_type || '-',
            tr.passport_country_code || '-',
            tr.fee,
            tr.transaction_create_time,
            tr.transaction_return_time || '-'
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickDetailTxt(row) {
      this.$refs.cardVerificationDetailModal.changModalStatus(true, row.transaction_id)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-verification-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
  }
  .show-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
